import { render } from "./PharmacyWireTransfer.vue?vue&type=template&id=62638f3a&scoped=true"
import script from "./PharmacyWireTransfer.vue?vue&type=script&lang=js"
export * from "./PharmacyWireTransfer.vue?vue&type=script&lang=js"

import "./PharmacyWireTransfer.vue?vue&type=style&index=0&id=62638f3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62638f3a"]])

export default __exports__